import React from "react";

const FAQ_section = ({ data }) => {
  return (
    <div className="container">
      <h3 className="h4 mt-35 mb-4">
        <span style={{ color: "#18336c" }}>{data[0]?.header}</span> Frequently
        Asked Questions (FAQs)
      </h3>

      <div className="accordion-area accordion" id="faqAccordion">
        {data.map((item, index) => {
          const isActive = index === 0 ? "show" : "";
          const isCollapsed = index !== 0 ? "collapsed" : "";
          const collapseId = `collapse-${index + 1}`;
          const headerId = `collapse-item-${index + 1}`;

          return (
            <div
              className={`accordion-card style2 ${isActive && "active"}`}
              key={index}
            >
              <div className="accordion-header" id={headerId}>
                <button
                  className={`accordion-button ${isCollapsed}`}
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={`#${collapseId}`}
                  aria-expanded={index === 0 ? "true" : "false"}
                  aria-controls={collapseId}
                >
                  {item.question}
                </button>
              </div>

              <div
                id={collapseId}
                className={`accordion-collapse collapse ${isActive}`}
                aria-labelledby={headerId}
                data-bs-parent="#faqAccordion"
              >
                <div className="accordion-body">
                  <p className="faq-text">{item.answer}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FAQ_section;
